export default __webpack_public_path__ + "static/media/leadersForStandardsAndSolutions.8cb77714.jpeg";